'use strict';

import React from 'react';
import * as atatus from 'atatus-spa';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import routes from '../routes/routes.js';
import AppNav from './utilities/AppNav.jsx';
import AnimatedSwitch from './utilities/AnimatedSwitch.jsx';
import OfflineBanner from './utilities/OfflineBanner.jsx';
import { refreshToken, processImageQueue, processPendingSaves } from '../helpers/AppDataHelper.js';
import { NetworkContext } from '../helpers/NetworkContext.js';

let parseQuery = (query = ``) => query.indexOf(`?`) !== 0 ? { } : query.split(`?`)[1].split(`&`).reduce((a, q) => {
  a[q.split(`=`)[0]] = q.split(`=`)[1];
  return a;
}, { });

const isUnauthedPage = (pathname) => {
  let paths = [`/login`, `/`];

  if (paths.includes(pathname)) {
    return true;
  }

  return false;
};

class App extends React.Component {
  constructor(props) {
    super(props);

    document.documentElement.style.setProperty(`--vh`, `${ window.innerHeight * 0.01 }px`);

    this.state = {
      hasError: false,
      isOnline: navigator.onLine
    };

    this.handleOnline = this.handleOnline.bind(this);
    this.handleOffline = this.handleOffline.bind(this);
    this.handleResize = () => {
      document.documentElement.style.setProperty(`--vh`, `${ window.innerHeight * 0.01 }px`);
    };
  }

  componentDidMount() {
    this.checkPath(this.props);

    if (this.props.isAuthed) refreshToken(this.props.refreshToken);

    window.addEventListener(`resize`, this.handleResize);
    window.addEventListener(`online`, this.handleOnline);
    window.addEventListener(`offline`, this.handleOffline);
  }

  componentWillUnmount() {
    window.removeEventListener(`resize`, this.handleResize);
    window.removeEventListener(`online`, this.handleOnline);
    window.removeEventListener(`offline`, this.handleOffline);
  }

  handleOnline() {
    this.setState({ isOnline: true });
    processImageQueue();
    processPendingSaves();
  }

  handleOffline() {
    this.setState({ isOnline: false });
  }

  componentWillReceiveProps(nextProps) {
    this.checkPath(nextProps);
  }

  componentDidCatch(error) {
    this.setState({ hasError: true });
    atatus.notify(error);
  }

  checkPath(props = this.props) {
    let fwd = encodeURIComponent(`${ props.location.pathname }${ props.location.search }`);

    if (parseQuery(props.location.search).r) {
      fwd = parseQuery(props.location.search).r;
    }

    if (!props.isAuthed && !isUnauthedPage(props.location.pathname)) {
      this.props.history.replace(`/login?r=${ fwd }`);
    } else if (props.isAuthed && isUnauthedPage(props.location.pathname)) {
      if (parseQuery(props.location.search).r) {
        props.history.replace(decodeURIComponent(parseQuery(props.location.search).r));
      } else {
        props.history.replace(`/projects`);
      }
    }
  }

  render() {
    if (this.state.hasError) return (
      <h1>Something went wrong.</h1>
    );

    return (
      <NetworkContext.Provider value={this.state.isOnline}>
        <main className={!this.state.isOnline ? `is-offline` : ``}>
          <OfflineBanner visible={!this.state.isOnline} />
          <AnimatedSwitch>
            { routes }
          </AnimatedSwitch>
          {
            !isUnauthedPage(this.props.location.pathname) && (
              <AppNav />
            )
          }
        </main>
      </NetworkContext.Provider>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthed: state.auth.isAuthed,
  refreshToken: state.auth.refreshToken
});

export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./src/components/App.jsx